var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { useEffect, useState } from 'react';
import lodash from 'lodash';
import { getFeatureSetAreas } from '@kareo/billing-system';
import featureToggles from '../../lib/sdk/featureToggles';
import { billerPermissionsNavBarLinks, careChecklistPermissionsNavBarLinks, careTeamPermissionsNavBarLinks, chartPermissionsNavBarLinks, documentsPermissionsNavBarLinks, flowsheetsPermissionsNavBarLinks, labsPermissionsNavBarLinks, notesPermissionsNavBarLinks, recallPermissionsNavBarLinks, } from '../constants';
import { fetchUserPermissions, getUserChartAccess, getChartNavbarConfigurationForUser, } from '../service/accessControl/service';
import { FeatureSetType, FeatureSetValue, } from '../service/accessControl/types';
var _a = lodash.noConflict(), sortBy = _a.sortBy, intersectionBy = _a.intersectionBy;
var useChartNavbarLinks = function (links, patientId) {
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState(billerPermissionsNavBarLinks), navbarLinks = _b[0], setNavbarLinks = _b[1];
    var _c = useState(false), careTeamFeatureToggleEnabled = _c[0], setCareTeamFeatureToggleEnabled = _c[1];
    var getNavBarConfiguration = function () { return __awaiter(void 0, void 0, void 0, function () {
        var navBarConfiguration;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    navBarConfiguration = [];
                    return [4 /*yield*/, getChartNavbarConfigurationForUser()
                            .then(function (configuration) {
                            var enabledLinks = configuration === null || configuration === void 0 ? void 0 : configuration.links.filter(function (link) { return link.enabled; });
                            navBarConfiguration.push.apply(navBarConfiguration, enabledLinks);
                        })
                            .catch(function (error) {
                            var _a;
                            (_a = window.rollbar) === null || _a === void 0 ? void 0 : _a.error(error);
                            navBarConfiguration.push.apply(navBarConfiguration, chartPermissionsNavBarLinks.filter(function (link) { return link.canBeConfigured; }));
                            navBarConfiguration.push.apply(navBarConfiguration, labsPermissionsNavBarLinks);
                            navBarConfiguration.push.apply(navBarConfiguration, flowsheetsPermissionsNavBarLinks);
                            throw error;
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, navBarConfiguration];
            }
        });
    }); };
    var fetchUserChartAccess = function () { return __awaiter(void 0, void 0, void 0, function () {
        var userChartAccessSettings, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getUserChartAccess(patientId)];
                case 1:
                    userChartAccessSettings = _b.sent();
                    return [2 /*return*/, __assign({}, userChartAccessSettings)];
                case 2:
                    error_1 = _b.sent();
                    (_a = window.rollbar) === null || _a === void 0 ? void 0 : _a.error(error_1);
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getPracticePermissions = function () { return __awaiter(void 0, void 0, void 0, function () {
        var clinicalProductEnabled, billingProductEnabled, recallEnabled, documentsEnabled, featureSets, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    clinicalProductEnabled = false;
                    billingProductEnabled = false;
                    recallEnabled = false;
                    documentsEnabled = false;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getFeatureSetAreas()];
                case 2:
                    featureSets = _b.sent();
                    clinicalProductEnabled =
                        featureSets[FeatureSetType.CLINICAL] === FeatureSetValue.ENABLED;
                    billingProductEnabled =
                        featureSets[FeatureSetType.BILLING] === FeatureSetValue.ENABLED;
                    recallEnabled =
                        featureSets[FeatureSetType.RECALL] === FeatureSetValue.ENABLED;
                    documentsEnabled =
                        featureSets[FeatureSetType.DOCUMENTS] === FeatureSetValue.ENABLED;
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _b.sent();
                    throw new Error(((_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.body) === null || _a === void 0 ? void 0 : _a.message) ||
                        'useChartNavbarLinks - error getting practice permissions');
                case 4: return [2 /*return*/, {
                        clinicalProductEnabled: clinicalProductEnabled,
                        billingProductEnabled: billingProductEnabled,
                        recallEnabled: recallEnabled,
                        documentsEnabled: documentsEnabled,
                    }];
            }
        });
    }); };
    var validateLink = function (configurationArray, navBarOption) {
        if (configurationArray.some(function (link) { return link.linkName === navBarOption.linkName; })) {
            return navBarOption;
        }
        return null;
    };
    var getNavBarLinksByPermissions = function (navBarConfiguration, practicePermissions, userPermissions, userAccess) {
        var navLinksArray = __spreadArrays(navbarLinks);
        var chartEnabled, notesEnabled, labsEnabled, flowsheetsEnabled, careChecklistEnabled, recallEnabled, documentsEnabled = false, careTeamEnabled = false;
        if (!userPermissions.protectionSettings.isPPCEnabled ||
            !userAccess.clinicalDataAccessRestrictionEnabled ||
            userAccess.userAccessLinked) {
            chartEnabled =
                practicePermissions.clinicalProductEnabled &&
                    userPermissions.userPrivileges.hasChartPrivilege;
            notesEnabled =
                practicePermissions.clinicalProductEnabled &&
                    userPermissions.userPrivileges.hasNotesPrivilege;
            labsEnabled =
                practicePermissions.clinicalProductEnabled &&
                    userPermissions.userPrivileges.hasLabsPrivilege;
            flowsheetsEnabled =
                practicePermissions.clinicalProductEnabled &&
                    userPermissions.userPrivileges.hasFlowsheetsPrivilege;
            careChecklistEnabled =
                practicePermissions.clinicalProductEnabled &&
                    userPermissions.userPrivileges.hasCareChecklistPrivilege;
            recallEnabled = practicePermissions.recallEnabled;
            documentsEnabled =
                userPermissions.userPrivileges.hasChartPrivilege &&
                    practicePermissions.documentsEnabled;
            careTeamEnabled =
                practicePermissions.clinicalProductEnabled &&
                    userPermissions.userPrivileges.hasChartPrivilege &&
                    careTeamFeatureToggleEnabled;
        }
        /* Check is user has chart permissions and if they have a navbar configuration set, if so return only the
        intersection of configuration array and configurable links but also all unconfigurable links */
        if (chartEnabled) {
            var configurableLinks = __spreadArrays(chartPermissionsNavBarLinks.filter(function (link) { return link.canBeConfigured; }));
            var unConfigurableLinks = __spreadArrays(chartPermissionsNavBarLinks.filter(function (link) { return !link.canBeConfigured; }));
            var configuredLinks = intersectionBy(configurableLinks, navBarConfiguration, 'linkName');
            navLinksArray.push.apply(navLinksArray, unConfigurableLinks.concat(configuredLinks));
        }
        if (notesEnabled) {
            navLinksArray.push.apply(navLinksArray, notesPermissionsNavBarLinks);
        }
        if (labsEnabled) {
            var labLink = validateLink(navBarConfiguration, labsPermissionsNavBarLinks[0]);
            if (labLink)
                navLinksArray.push(labLink);
        }
        if (flowsheetsEnabled) {
            var flowsheetsLink = validateLink(navBarConfiguration, flowsheetsPermissionsNavBarLinks[0]);
            if (flowsheetsLink)
                navLinksArray.push(flowsheetsLink);
        }
        if (careChecklistEnabled) {
            navLinksArray.push.apply(navLinksArray, careChecklistPermissionsNavBarLinks);
        }
        if (documentsEnabled) {
            navLinksArray.push.apply(navLinksArray, documentsPermissionsNavBarLinks);
        }
        if (recallEnabled) {
            navLinksArray.push.apply(navLinksArray, recallPermissionsNavBarLinks);
        }
        if (careTeamEnabled) {
            navLinksArray.push.apply(navLinksArray, careTeamPermissionsNavBarLinks);
        }
        var sortedLinks = sortBy(navLinksArray, ['displayOrder']);
        return sortedLinks;
    };
    useEffect(function () {
        // Check Care Team feature toggle
        featureToggles
            .isEnabled('dark-feature.care-team-members')
            .then(function (featureToggleEnabled) {
            setCareTeamFeatureToggleEnabled(!!featureToggleEnabled);
        });
    }, []);
    useEffect(function () {
        /* If no links supplied as param  - i.e. not available to component - check permissions and facesheet configuration
        and return appropriate chart navbar links */
        if (patientId > 0 && !links) {
            Promise.all([
                fetchUserPermissions(),
                fetchUserChartAccess(),
                getPracticePermissions(),
                getNavBarConfiguration(),
            ].map(function (p) { return p.catch(function () { return undefined; }); }))
                .then(function (_a) {
                var userPermissions = _a[0], chartAccess = _a[1], practicePermissions = _a[2], navBarConfiguration = _a[3];
                var sortedLinks = getNavBarLinksByPermissions(navBarConfiguration, practicePermissions, userPermissions, chartAccess);
                setNavbarLinks(sortedLinks);
            })
                .catch(function (error) {
                var _a;
                throw new Error(((_a = error === null || error === void 0 ? void 0 : error.body) === null || _a === void 0 ? void 0 : _a.message) ||
                    'useChartNavbarLinks - Error loading navbar links');
            })
                .finally(function () {
                setLoading(false);
            });
        }
        else {
            setLoading(false);
        }
    }, [patientId]);
    return {
        loading: loading,
        navbarLinks: navbarLinks,
    };
};
export default useChartNavbarLinks;
